import React, { createContext, useContext, useReducer, PropsWithChildren } from 'react';
import { OfficialDailyDetailReducer, initialState, IOfficialDailyDetailState, ACTION_TYPES } from './official-daily-detail-reducer';

const OfficialDailyDetailStateContext = createContext<IOfficialDailyDetailState | undefined>(undefined);
const OfficialDailyDetailDispatchContext = createContext<React.Dispatch<any> | undefined>(undefined);

export const OfficialDailyDetailProvider = ({ children }: PropsWithChildren<{}>) => {
    const [state, dispatch] = useReducer(OfficialDailyDetailReducer, initialState);

    return (
        <OfficialDailyDetailStateContext.Provider value={state}>
            <OfficialDailyDetailDispatchContext.Provider value={dispatch}>
                {children}
            </OfficialDailyDetailDispatchContext.Provider>
        </OfficialDailyDetailStateContext.Provider>
    );
};

export const useOfficialDailyDetailState = () => {
    const context = useContext(OfficialDailyDetailStateContext);
    if (context === undefined) {
        throw new Error('useOfficialDailyDetailState must be used within OfficialDailyDetailProvider');
    }
    return context;
};

export const useOfficialDailyDetailDispatch = () => {
    const context = useContext(OfficialDailyDetailDispatchContext);
    if (context === undefined) {
        throw new Error('useOfficialDailyDetailDispatch must be used within OfficialDailyDetailProvider');
    }
    return context;
};

export { ACTION_TYPES };
